import { ProductRecommendationsLine } from 'Components/lines/product-recommendations-line/ProductRecommendationsLine';
export default ProductRecommendationsLine;
